
import { Component, Vue, Prop } from "vue-property-decorator";
import { ru } from "vuejs-datepicker/dist/locale";

import subscriptions_routes from "@/api/routes/subscriptions";

import { IStudentProgramsData } from "@/models/subscriptions/program";

import {
  ESubscriptionStatus,
  ESubscriptionProgressStatus
} from "@/models/subscriptions/status";

@Component({
  name: "CTeamSubscription"
})
export default class CTeamSubscription extends Vue {
  @Prop({ required: true }) public subscription!: IStudentProgramsData;

  public ru = ru;

  $refs!: {
    datepicker_period: HTMLDivElement;
  };

  public ESubscriptionStatus = ESubscriptionStatus;
  public ESubscriptionProgressStatus = ESubscriptionProgressStatus;

  public progressColor() {
    switch (this.subscription.program_status) {
      case ESubscriptionStatus.AWAITING_COMPLETION:
      case ESubscriptionStatus.AWAITING_CONFIRMATION:
        return "#FFAB00";
      case ESubscriptionStatus.FAILED:
        return "#FA4747";
      default:
        return "#1E64AA";
    }
  }

  public toggleDatepicker() {
    this.$refs.datepicker_period.classList.toggle("open");
  }

  public async changeSubscriptionDate() {
    return this.$api
      .put(subscriptions_routes.subscription_program(this.subscription.id), {
        starts_at: this.subscription.starts_at,
        deadline_at: this.subscription.deadline_at
      })
      .then(() => {
        this.$notify({
          group: "notifications",
          type: "success",
          text: "Изменения сохранены",
          speed: 500
        });
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
